import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { gql, ResultOf, FragmentOf } from '@/utilities/gql';

export const PORTFOLIO_HOLDINGS_DIVIDEND_FORECAST_FRAGMENT = gql(`
  fragment portfolioHoldingsDividendForecastFields on HoldingDividendForecast @_unmask{
    isAnalysisRestricted
    company {
      id
      name
      canonicalURL
      exchangeCountryISO
      tickerSymbol
      exchangeSymbol
      uniqueSymbol
      score {
        value
        future
        past
        health
        dividend
        sentence
        total
      }
    }
    dividendForecast {
      last1y {
        payment,
        dividendYield,
        yieldOnCapitalInvested
        dividendPaymentsGrowthAnnual,
      }
      next1y {
        payment,
        dividendYield,
        yieldOnCapitalInvested
        dividendPaymentsGrowthAnnual,
      }
      next2y {
        payment,
        dividendYield,
        yieldOnCapitalInvested
        dividendPaymentsGrowthAnnual,
      }
      next3y {
        payment,
        dividendYield,
        yieldOnCapitalInvested
        dividendPaymentsGrowthAnnual,
      }
    }
  }
`);

const QUERY = gql(
  `
  query getPortfolioHoldingsDividendForecast($portfolioId: String!) {
    Portfolio(id: $portfolioId) {
      holdingsDividendForecast {
        ...portfolioHoldingsDividendForecastFields
      }
    }
  }
`,
  [PORTFOLIO_HOLDINGS_DIVIDEND_FORECAST_FRAGMENT]
);

type HookParams = {
  portfolioId: string;
};

export const usePortfolioHoldingsDividendForecastCreator =
  (currencyISO: string) =>
  ({ portfolioId }: HookParams) => {
    return makeGqlSuspenseQuery(QUERY, {
      queryKey: ['getPortfolioHoldingsDividendForecast', currencyISO],
    })({
      portfolioId,
    });
  };

export type PortfolioDividendForecastData = Omit<
  ResultOf<typeof QUERY>,
  'samplePortfolioHoldingsDividendForecast'
>;

export type PortfolioDividendHolding = FragmentOf<
  typeof PORTFOLIO_HOLDINGS_DIVIDEND_FORECAST_FRAGMENT
>;
